import ImageBasic from "../../Common/Image/ImageBasic";
import IMG from "../../../constants/image";
import React from "react";
import {text} from "../../../constants/text";

const CourierInfo = () => (
    <div className="min-w-[353px] md:min-w-[590px] rounded-[10px] overflow-hidden">
        <div className="text-center text-sm font-medium bg-[#E8F2EE] py-[5px]">
            {text.transportByFutaFunongPartner}
        </div>
        <div className="flex items-center justify-center md:justify-between p-4 bg-[#F3F8F6]">
            <div className="flex items-center space-x-10 md:space-x-5">
                <ImageBasic src={IMG.logo.futae} alt="FUTA Express logo" className="mr-2"/>
                <div>
                    <div className="text-xs text-gray-500">{`${text.shippingCompany}:`}</div>
                    <div className="font-medium text-sm">{text.futaExpress}</div>
                </div>
            </div>
            <ImageBasic className='hidden md:block' src={IMG.logo.selfDelivery} alt="Delivery truck"/>
        </div>
    </div>
);
export default CourierInfo;